"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BrandGwsGameProviderSegmentationEditor_1 = require("./BrandGwsGameProviderSegmentationEditor");
var BrandGwsGameProviderSegmentationsList_1 = require("./BrandGwsGameProviderSegmentationsList");
var BrandGwsGameProviderSegmentationOperations = /** @class */ (function (_super) {
    __extends(BrandGwsGameProviderSegmentationOperations, _super);
    function BrandGwsGameProviderSegmentationOperations(props) {
        return _super.call(this, props) || this;
    }
    BrandGwsGameProviderSegmentationOperations.prototype.componentWillMount = function () {
        this.setState({
            mode: "LIST",
            record: null
        });
        this.props.state.setExtBreadCrumbPath(["Управление сегментацией"]);
    };
    BrandGwsGameProviderSegmentationOperations.prototype.onBackToRootClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    BrandGwsGameProviderSegmentationOperations.prototype.onNewClick = function () {
        this.setState({ mode: "NEW", record: null });
    };
    BrandGwsGameProviderSegmentationOperations.prototype.onEditClick = function (record) {
        this.setState({ mode: "EDIT", record: record });
    };
    BrandGwsGameProviderSegmentationOperations.prototype.onBackToListClick = function () {
        this.setState({ mode: "LIST", record: null });
    };
    BrandGwsGameProviderSegmentationOperations.prototype.getTemplateImagesObject = function () {
        if (this.state.mode === "LIST") {
            return (React.createElement(BrandGwsGameProviderSegmentationsList_1.default, { state: this.props.state, onCreateClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onGoBackClick: this.onBackToRootClick.bind(this), data: this.props.data, record: this.props.rootRecord }));
        }
        if (this.state.mode === "NEW") {
            return (React.createElement(BrandGwsGameProviderSegmentationEditor_1.default, { state: this.props.state, onGoBack: this.onBackToListClick.bind(this), data: this.props.data, record: null, rootRecord: this.props.rootRecord, ListGwsGameProviderZonesAvail: this.props.ListGwsGameProviderZonesAvail, ListPlayerBehaviorTypesAvail: this.props.ListPlayerBehaviorTypesAvail, ListTresholdBehaviorTypesAvail: this.props.ListTresholdBehaviorTypesAvail, ListBonusLevelsAvail: this.props.ListBonusLevelsAvail }));
        }
        if (this.state.mode === "EDIT") {
            return (React.createElement(BrandGwsGameProviderSegmentationEditor_1.default, { state: this.props.state, onGoBack: this.onBackToListClick.bind(this), data: this.props.data, record: this.state.record, rootRecord: this.props.rootRecord, ListGwsGameProviderZonesAvail: this.props.ListGwsGameProviderZonesAvail, ListPlayerBehaviorTypesAvail: this.props.ListPlayerBehaviorTypesAvail, ListTresholdBehaviorTypesAvail: this.props.ListTresholdBehaviorTypesAvail, ListBonusLevelsAvail: this.props.ListBonusLevelsAvail }));
        }
        throw "No available render for active edit mode -> " + this.state.mode;
    };
    BrandGwsGameProviderSegmentationOperations.prototype.render = function () {
        return (React.createElement("div", null, this.getTemplateImagesObject()));
    };
    return BrandGwsGameProviderSegmentationOperations;
}(React.Component));
exports.default = BrandGwsGameProviderSegmentationOperations;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/gateways/gameprovider/BrandGwsGameProviderSegmentationOperations.tsx
// module id = 1795
// module chunks = 0